import { useEffect, useState } from 'react';
import ButtonItem from '../../components/ButtonItem';

function Compose() {
  const [folders, setFolders] = useState([]);
  const [folder, setFolder] = useState('');
  const [audio, setAudio] = useState(null);
  const [overlay, setOverlay] = useState(null);
  const [count, setCount] = useState('1');
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const r = await fetch('http://localhost:3000/compose/folders');
        const d = await r.json();
        setFolders(d?.folders || []);
        if (d?.folders?.length) setFolder(d.folders[0].name);
      } catch {
        setMsg('폴더 목록을 불러오지 못했습니다.');
      }
    })();
  }, []);

  const onCount = (e) => setCount(e.target.value.replace(/[^0-9]/g, ''));

  const submit = async () => {
    if (!folder) return alert('폴더를 선택하세요.');
    if (!audio) return alert('음원을 선택하세요.');
    if (!overlay) return alert('PNG 이미지를 선택하세요.');
    if (!Number(count)) return alert('생성 개수는 1 이상이어야 합니다.');

    setLoading(true);
    setMsg('');
    try {
      const fd = new FormData();
      fd.append('folder', folder);
      fd.append('count', String(Number(count)));
      fd.append('fadeInMs', '800'); // 고정
      fd.append('fadeOutMs', '800'); // 고정
      fd.append('audio', audio);
      fd.append('overlay', overlay);

      const r = await fetch('http://localhost:3000/compose', {
        method: 'POST',
        body: fd,
      });
      if (!r.ok) {
        const d = await r.json().catch(() => ({}));
        throw new Error(d?.errorMessage || '합성 오류');
      }
      setMsg('✅ 완료: output 폴더를 확인하세요.');
    } catch (e) {
      setMsg(`❌ ${e.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-dvh h-dvh flex flex-col items-center overflow-y-auto p-12">
      <div className="w-full mb-10 text-3xl text-center font-bold">
        영상 합성 (이미지+음원)
      </div>

      <div className="w-[500px] flex flex-col space-y-6">
        <div>
          <label className="block text-lg font-semibold mb-1">폴더 선택</label>
          <select
            value={folder}
            onChange={(e) => setFolder(e.target.value)}
            className="w-full h-12 px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200">
            {folders.map((f) => (
              <option key={f.name} value={f.name}>
                {f.name}
                {typeof f.count === 'number' ? ` (영상 ${f.count}개)` : ''}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-lg font-semibold mb-1">음원 선택</label>
          <input
            type="file"
            accept="audio/*"
            onChange={(e) => setAudio(e.target.files?.[0] || null)}
            className="w-full h-12 px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200"
          />
        </div>

        <div>
          <label className="block text-lg font-semibold mb-1">
            이미지 선택 (투명 PNG)
          </label>
          <input
            type="file"
            accept="image/png"
            onChange={(e) => setOverlay(e.target.files?.[0] || null)}
            className="w-full h-12 px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200"
          />
        </div>

        <div>
          <label className="block text-lg font-semibold mb-1">생성 개수</label>
          <input
            type="text"
            inputMode="numeric"
            value={count}
            onChange={onCount}
            className="w-full h-12 px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200"
            placeholder="예) 5"
          />
        </div>

        <div className="pt-2">
          <ButtonItem
            text={loading ? '합성 중...' : '합성 시작'}
            color="blue"
            className="w-full h-14 rounded-xl text-xl"
            onClick={submit}
            disabled={loading}
          />
        </div>

        {msg && <div className="text-sm">{msg}</div>}
      </div>
    </div>
  );
}

export default Compose;
